import React from "react";
import { createRoot } from "react-dom/client";
import Slider from "../components/Slider/Slider";

const renderMuseumSlider = ($) => {
	const sliders = $(".js-museum-slider").toArray();

	if (sliders.length > 0) {

		// Loop through each slider and render the component
		sliders.forEach((slider) => {
			let props = {...slider.dataset};
	
			const root = createRoot(slider);
			root.render(<Slider {...props} />);
		});

	}
};

export default renderMuseumSlider;
